import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.primaryBackgroundColor};
  background-image: ${'url("https://res.cloudinary.com/cordasemusica/image/upload/f_webp/v1678224794/bg-login_o2rsli.png")'};
  background-attachment: fixed;
  background-size: 50px;
  background-position: right bottom;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  overflow: hidden;

  ::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background: #33333366;
    z-index: 2;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 3;
  border-radius: 0.5rem;
  box-shadow: 2px 2px 5px #333;

  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;
  width: 95vw;
  max-width: 500px;

  @media ${device.mobileL} {
    width: 90vw;
  }

  @media ${device.tablet} {
    align-items: normal;
  }
`

export const FormContainer = styled.div`
  width: 100%;
  flex: 1;
  padding: 2rem 0.3rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.palette.white};

  @media ${device.mobileM} {
    padding: 2rem 1rem;
  }

  .form-content {
    width: 100%;
    padding: 1rem 0.5rem 2rem;
    overflow: hidden;

    @media ${device.mobileM} {
      padding: 1rem 1rem 2rem;
    }

    form {
      overflow: hidden;
    }

    button {
      width: 100%;
      margin-top: 0.6rem;
      text-transform: uppercase;
      div {
        width: 100%;
      }
      :hover {
        filter: brightness(90%);
      }
    }

    .info {
      display: inline-block;
      text-align: center;
      margin: 0 auto;
    }
  }

  a {
    ${({ theme }) => ({ ...theme.size.xs })};
    :hover {
      text-decoration: underline;
    }
  }
`

export const StepContainer = styled.div<{ num: string }>`
  width: 300%;
  display: flex;
  overflow: hidden;
  transition: all 0.3s;
  margin-left: ${({ num }) => num};
`

export const Step = styled.div`
  width: 100%;
  padding: 1rem 0;
  position: relative;
  display: block;

  .step-header {
    margin: 0 0 2rem;
  }

  h1 {
    margin: 0 auto 0.3rem;
    ${({ theme }) => ({ ...theme.size.lg })};
    color: ${({ theme }) => theme.colors.secondaryTextColor};
    @media ${device.laptopL} {
      padding-top: 1rem;
      ${({ theme }) => ({ ...theme.size.xl })}
    }
  }
`

export const Pointers = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  .pointer {
    width: 40px;
    height: 40px;
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.palette.neutral400};
    border: 3px solid ${({ theme }) => theme.colors.palette.neutral400};
    transition: all 0.2s;

    span {
      ${({ theme }) => ({ ...theme.typography.primary.bold })}
    }

    &.active {
      transform: scale(1.2);
      margin: 0 0 0 0.5rem;
      color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
      border-color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    }
  }

  .pointer + .pointer {
    margin-left: 1.2rem;
  }
`
